import { translateText } from '@/i18n'

/**
 * 全局 Toast 提示插件
 * 用法: this.$toast('消息内容', 'success' | 'error' | 'info')
 */
const ToastPlugin = {
  install(Vue) {
    let toastContainer = null
    let currentToast = null

    function ensureContainer() {
      if (toastContainer && document.body.contains(toastContainer)) return toastContainer
      toastContainer = document.createElement('div')
      toastContainer.id = 'global-toast-container'
      document.body.appendChild(toastContainer)
      return toastContainer
    }

    function showToast(message, type = 'info') {
      // 先移除已有的 toast
      if (currentToast && currentToast.parentNode) {
        currentToast.parentNode.removeChild(currentToast)
        clearTimeout(currentToast._timer)
      }

      const toast = document.createElement('div')
      toast.className = 'global-toast global-toast-' + type
      const locale = localStorage.getItem('dapp_locale') || 'zh-CN'
      toast.textContent = translateText(String(message), locale)
      ensureContainer().appendChild(toast)
      currentToast = toast

      toast._timer = setTimeout(() => {
        if (toast.parentNode) toast.parentNode.removeChild(toast)
        if (currentToast === toast) currentToast = null
      }, 3000)
    }

    // 注入全局样式
    const style = document.createElement('style')
    style.textContent = `
      #global-toast-container {
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 99999;
        pointer-events: none;
      }
      .global-toast {
        pointer-events: auto;
        background: #fff;
        padding: 12px 24px;
        border-radius: 8px;
        font-size: 14px;
        box-shadow: 0 4px 16px rgba(0,0,0,0.15);
        margin-bottom: 8px;
        animation: toastSlideIn 0.3s ease;
        max-width: 80vw;
      }
      .global-toast-success { color: #52c41a; border-left: 4px solid #52c41a; }
      .global-toast-error { color: #ff4d4f; border-left: 4px solid #ff4d4f; }
      .global-toast-info { color: #1890ff; border-left: 4px solid #1890ff; }
      @keyframes toastSlideIn {
        from { opacity: 0; transform: translateY(-20px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `
    document.head.appendChild(style)

    Vue.prototype.$toast = showToast
  }
}

export default ToastPlugin
